import { type Ref, computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useLogo } from '@/composables/useLogo.ts'
import { useScrollLock } from '@/composables/useScrollLock.ts'

export const useNavigation = (transparent: Ref<boolean>) => {
  const route = useRoute()

  const open = ref(false)
  const logo = computed(() => useLogo(open.value || !transparent.value))

  watch(
    () => route.fullPath,
    () => {
      open.value = false
    },
  )

  const close = () => (open.value = false)
  const toggleOpen = () => (open.value = !open.value)

  useScrollLock(open)

  return { logo, open, close, toggleOpen }
}
